import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './@theme/index';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceCallsService } from './@core/index';
import { WebStorageModule } from 'ngx-store-9';
import { HttpClientModule } from '@angular/common/http';


@NgModule({
  imports: [
    CommonModule, RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    WebStorageModule,
  ],
  declarations: [HeaderComponent],
  exports: [
    FormsModule,
    HeaderComponent,
    RouterModule,
    HttpClientModule,
    WebStorageModule
  ],
})
export class SharedModule { }
